'use strict'
//公钥测试
let PUBLIC_KEY = '-----BEGIN EC PUBLIC KEY-----\n' +
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA49IXLP9h2eHpZaCqM2W3\n' +
  'pDR16n+X7WvATQ0nIRg7gCb6JNwmRy3Ucv9MzEKSJ+CKarq78zefDo7O07k/N7TM\n' +
  'LOu2Zmn7o/GZiDK9EJ/FZPdTxCSS1zq2XN+HtMdEgQucYcN0+qbvkEjKwP74iL8C\n' +
  'JfgudbuVmxPfEKp8mLSDIzPPvakkeHS7hydiip2mIAiOVixCcb/w+Js5P48iMaVD\n' +
  '8P6BIFH6GzuuEVr6U/Wk+8eWRaW0VmqGnZpqh/nyUSv5xsN9rlF9I8Yki9IWoNU8\n' +
  'Pfjy5GMCKoPS7xsiD8cWRuj2sx4oqSsUdbqvmDexmr5etQZyUgIOkvJuP5boPy62\n' +
  'bQIDAQAB\n' +
  '-----END EC PUBLIC KEY-----';
//生产公钥

const TITLE_ENV = '智慧校园管理平台';

module.exports = {
  PUBLIC_KEY,
  TITLE_ENV,
  NODE_ENV: '"production"',

  // API_BASEURL: '"http://zhxy.xyruxue.com/api"', //本地地址--测式-多校
  // UPLOADER_URL: '"http://zhxy.xyruxue.com/"', //上传图片地址--测式
  // TEMPLATE_URL: '"http://zhxy.xyruxue.com/public"', //模板下载地址--测式
  // SOCKET_URL: '"ws://219.139.176.154:8005"',//socket 地址--测试

  API_BASEURL: '"https://xy.xysmartedu.com/api"', //本地地址--正式的测试-多校
  UPLOADER_URL: '"https://xy.xysmartedu.com/"', //上传图片地址--正式的测试
  TEMPLATE_URL: '"https://xy.xysmartedu.com/public"', //模板下载地址--正式的测试
  SOCKET_URL: '"ws://111.170.12.172:8005"',//socket 地址--正式的测试


  // API_BASEURL: '"https://xw.xysmartedu.com/api"', //本地地址--正式的测试-红光
  // UPLOADER_URL: '"https://xw.xysmartedu.com/"', //上传图片地址--正式的测试
  // TEMPLATE_URL: '"https://xw.xysmartedu.com/public"', //模板下载地址--正式的测试
  // SOCKET_URL: '"ws://111.170.12.172:8005"',//socket 地址--正式的测试  
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 239